import { mapListener, getTypeForNode } from 'Services/WeaverUtils'
import { TypeSizes } from 'Model'
class SizeService
  constructor: ->
    @allSizes = {
      'xs': 5
      'sm': 7.5
      'md': 10
      'lg': 20
      'xl': 30
    }
    @sizeMap = {}

  init: ->
    try
      @sizeMap = (await TypeSizes.load()).map()
    catch
      @sizeMap = {}

    if _.isString(@sizeMap)
      @sizeMap = _.reduce(@sizeMap.split('#!#'), (acc, val) ->
        [key, val] = val.split('#?#')
        { acc..., [key]: val }
      , {})
      (await TypeSizes.load()).update(@sizeMap)

    @sizes = mapListener(@sizeMap, _.debounce(=>
      (await TypeSizes.load()).update(@sizeMap)
    , 100))

  getNodeSizeByAttribute: (size) ->
    if size < 1 then size = 1
    Math.floor((Math.log10(size)) * 10) + 10

  getSizeForType: (type) ->
    parseInt(@sizes[type] ?= @allSizes['md'])

  setSizeForType: (type, size) ->
    @sizes[type] = @allSizes[size]

  getSizeForNode: (node) ->
    @getSizeForType(getTypeForNode(node))

export default new SizeService()
